// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productQuantityBreakPricingStyles } from "@eisinc/Overrides/Components/ProductQuantityBreakPricing";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { color } from "@eisinc/XDL/Utilities";
import { css } from "styled-components";

productQuantityBreakPricingStyles.wrapper = {
    css: css`
        margin: 0 -20px -20px -20px;
        padding: 20px 20px;
        background-color: ${color("common.white")};
        border-bottom-left-radius: 20px;
        border-bottom-right-radius: 20px;
    `,
};
productQuantityBreakPricingStyles.tableRow = {
    css: css`
        background: ${color("common.white")} !important;
        border-bottom: 1px solid ${color("common.ui2")};
    `,
};
productQuantityBreakPricingStyles.title = {
    variant: "p",
    size: fontConfig.singleLineSmall.size,
    weight: fontConfig.weight.medium,
    lineHeight: fontConfig.singleLineSmall.lineHeight,
    css: css`
        margin-bottom: 10px;
    `,
};
productQuantityBreakPricingStyles.breakQtyCell = {
    alignX: "left",
    css: css`
        font-size: ${fontConfig.singleLinexSmall.size}px;
        font-weight: ${fontConfig.weight.medium};
        color: ${color("text")};
        padding: 0 10px 0 0;
        height: 30px;
        vertical-align: middle;
    `,
};
productQuantityBreakPricingStyles.breakPriceCell = {
    alignX: "left",
    css: css`
        font-size: ${fontConfig.singleLinexSmall.size}px;
        color: ${color("text")};
        padding: 0 0 0 10px;
        width: 100%;
        height: 30px;
        vertical-align: middle;
    `,
};